






































































import Vue, { PropType } from "vue";
import Locale from "@/service/Locale/Locale";

import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import { required, max } from "vee-validate/dist/rules";

extend("required", required);
extend("max", max);

const ADMINISTRATOR_NAME_MAX_COUNT = 190;

interface JoinInputUserInfoFormProps {
  csrfToken: string;
  identifier: string;
  lang: any;
  userName: string;
}

interface JoinInputUserInfoFormData {
  editUserName: string;
  inputRule: string;
}

export default Vue.extend({
  name: "vc-join-user-info-form",
  components: {
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    csrfToken: {
      type: String,
      default: "",
    },
    identifier: {
      type: String,
      default: "",
    },
    lang: {
      type: Object as PropType<JoinInputUserInfoFormProps["lang"]>,
      default: () => {},
    },
    userName: {
      type: String,
      default: "",
    },
  },
  data(): JoinInputUserInfoFormData {
    return {
      editUserName: this.userName,
      inputRule: "required|max:" + ADMINISTRATOR_NAME_MAX_COUNT,
    };
  },
  mounted() {
    const locale = Locale.getLocale();
    localize(locale, {
      messages: {},
      fields: {
        userNameProvider: {
          required: this.lang.input_error.required,
          max: this.lang.input_error.length.replace(
            ":length",
            ADMINISTRATOR_NAME_MAX_COUNT
          ),
        },
      },
    });
  },
});
